import { Component, OnInit, Input } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { GraphData } from '../../interfaces/graph-data.model';

@Component({
  selector: 'app-semi-donut',
  templateUrl: './semi-donut.component.html',
  styleUrls: ['./semi-donut.component.scss']
})
export class SemiDonutComponent implements OnInit {
  @Input() data: GraphData[];
  @Input() estimate: number;
  @Input() title: string;
  @Input() subtitle: string;

  constructor(private sanitizer: DomSanitizer) { }

  ngOnInit() {
    if (this.title === '') {
      this.title = '0';
    }
  }

  getDegrees(data, index) {
    const degrees = data
      .map((value) => (value.value / this.estimate) * 180)
      .map((value, i, arr) => arr
        .filter((value2, i2) => i2 <= i)
        .reduce((a, b) => a + b, 0)
      );

    degrees.unshift(0);
    degrees.pop();

    return this.sanitizer.bypassSecurityTrustStyle(`transform: rotate(${degrees[index]}deg);`);
  }

  getIEDegrees(data, index) {
    const degrees = data
      .map((value) => (value.value / this.estimate) * 180)
      .map((value, i, arr) => arr
        .filter((value2, i2) => i2 <= i)
        .reduce((a, b) => a + b, 0)
      );

    degrees.unshift(0);
    degrees.pop();
    if (isNaN(degrees[index])) {
      return '';
    }

    return `rotate(${degrees[index]} 132 132)`;
  }
}



// WEBPACK FOOTER //
// ./src/app/components/semi-donut/semi-donut.component.ts